var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"165296da0bd0f0720b13a0ead7e9c5dd7cf6eec4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["curiouspage@curious-expeditions"]={id:"165296da0bd0f0720b13a0ead7e9c5dd7cf6eec4"};
      